import { isSetRestSetDataUtil, WORKOUT_EXERCISE_KEY } from '../../../model'
import { SET_DATA_KEY, WORKOUT_EXERCISE_CLASS_NAME } from '../../../model/constants'
import {
  createFromExerciseTypeSetDataUtil,
  getNonRestSetsCountSetDataUtil,
  getSetDataWorkoutExerciseUtil
} from '../../../model/utils'
import getWorkoutExercisesWorkoutSectionUtil from '../../../../workout-section/model/utils/get-workout-exercises'
import { EXERCISE_KEY } from '../../../../exercise'
import getByIdExerciseSelector from '../../../../exercise/redux/selectors/get-by-id'
import { getCurrentOrCustomerIdProfileSelect } from '../../../../profile/redux/selectors/get-current-or-customer-id'
import { getWeightUnitProfileSelect } from '../../../../profile/redux/selectors/get-weight-unit'
import createReduxAction from '../../../../redux/actions/create'
import createPointerReduxUtil from '../../../../redux/utils/create-pointer'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import updateCurrentWorkoutExerciseAction from '../set-current'
import { updateSetDataFromProfileWorkoutExerciseAction } from '../update-set-data-from-profile'
import WORKOUT_EXERCISES_ACTION from '../../constants/action'
import { getCircuitRoundsWorkoutSectionSelector } from '../../../../workout-section/redux/selectors/get-circuit-data'
import getCurrentWorkoutSectionSelect from '../../../../workout-section/redux/selectors/get-current'
import getCurrentWorkoutExercisesWorkoutSectionSelect
  from '../../../../workout-section/redux/selectors/get-current-workout-exercises'
import isCircuitWorkoutSectionSelector from '../../../../workout-section/redux/selectors/is-circuit'
import getCurrentOrStartedIdWorkoutSelect from '../../../../workout/redux/selectors/get-current-or-started-id'
import { rangeArrayUtil } from 'packages/src'

function getSetDataActionFromOtherWorkoutExercises (exercise) {
  return (dispatch, getState) => {
    const weightUnit = getWeightUnitProfileSelect(getState())
    const workoutExercises = getCurrentWorkoutExercisesWorkoutSectionSelect(
      getState())
    const lastWorkoutExercise = workoutExercises[workoutExercises.length - 1]
    const lastWorkoutExerciseSetData = getSetDataWorkoutExerciseUtil(
      lastWorkoutExercise)
    const lastWorkoutExerciseRestSets = lastWorkoutExerciseSetData.filter(
      isSetRestSetDataUtil)
    const lastWorkoutExerciseHasRest = !!lastWorkoutExerciseRestSets.length
    const isCircuit = isCircuitWorkoutSectionSelector(getState())

    let setsCount
    let setData
    if (lastWorkoutExercise && isCircuit) {
      // If it's a circuit, add this exercise at the end and remove the rest
      // from the last set (if available)
      const rounds = getCircuitRoundsWorkoutSectionSelector(getState())
      // TODO handle unilateral exercises
      setsCount = rounds.length
    } else if (lastWorkoutExercise) {
      // Get the same number of sets as the last workout exercise
      setsCount = getNonRestSetsCountSetDataUtil(lastWorkoutExerciseSetData)
    }

    if (setsCount) {
      rangeArrayUtil(0, setsCount)
        .forEach((index) => {
          let newSetData = createFromExerciseTypeSetDataUtil({
            exercise,
            weightUnit
          })

          const hasRest = !!newSetData.find(set => set[SET_DATA_KEY.REST] !=
            null)

          let newRest
          if (lastWorkoutExerciseHasRest) {
            const restSet = (
              lastWorkoutExerciseRestSets[index] ||
              lastWorkoutExerciseRestSets[0]
            )
            newRest = restSet[SET_DATA_KEY.REST]
          }

          if (newRest && hasRest) {
            // Replace the rest
            newSetData = newSetData.map(set => {
              if (set[SET_DATA_KEY.REST] != null) {
                return {
                  ...set,
                  [SET_DATA_KEY.REST]: newRest
                }
              }
              return set
            })
          }

          if (newRest && !hasRest) {
            // Add the rest, mimic previous exercises (e.g. circuit)
            newSetData.push({
              [SET_DATA_KEY.REST]: newRest
            })
          }

          setData = [
            ...(
              setData || []
            ),
            ...newSetData
          ]
        })
    }

    if (!setData) {
      setData = createFromExerciseTypeSetDataUtil({
        exercise,
        weightUnit
      })
    }

    return setData
  }
}

export default function createWorkoutExerciseAction ({
  exerciseId,
  ...updates
}) {
  return (dispatch, getState) => {
    const exercise = getByIdExerciseSelector(exerciseId)(getState())
    const setData = dispatch(getSetDataActionFromOtherWorkoutExercises(exercise))
    const workoutSection = getCurrentWorkoutSectionSelect(getState())
    const workoutExercises = getWorkoutExercisesWorkoutSectionUtil(
      workoutSection)
    const workoutExercise = dispatch(createReduxAction({
      type: WORKOUT_EXERCISES_ACTION.CREATE,
      payload: {
        data: {
          className: WORKOUT_EXERCISE_CLASS_NAME,
          changed: {
            [WORKOUT_EXERCISE_KEY.SET_DATA]: setData,
            [WORKOUT_EXERCISE_KEY.NOTES]: '',
            [WORKOUT_EXERCISE_KEY.PROFILE_ID]: getCurrentOrCustomerIdProfileSelect(
              getState()),
            [WORKOUT_EXERCISE_KEY.WORKOUT_ID]: getCurrentOrStartedIdWorkoutSelect(
              getState()),
            [WORKOUT_EXERCISE_KEY.EXERCISE]: createPointerReduxUtil(exercise,
              [EXERCISE_KEY.NAME]
            ),
            [WORKOUT_EXERCISE_KEY.ORDER]: workoutExercises.length + 1,
            [WORKOUT_EXERCISE_KEY.EXERCISE_ID]: getIdReduxUtil(exercise),
            [WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID]: getIdReduxUtil(
              workoutSection),
            ...updates
          }
        }
      }
    }))

    dispatch(updateSetDataFromProfileWorkoutExerciseAction({
      workoutExercise
    }))

    dispatch(updateCurrentWorkoutExerciseAction(getIdReduxUtil(workoutExercise)))
  }
}
